module.exports = __webpack_public_path__ + "img/main-background-right.246fb65e.png";